export const NOT_AVAILABLE = 'Not Available';
export const COMPANY_LOGO = '/static/logos/kalolyticLogo.svg';
export const COMPANY_LOGO_APPLICATION = '/static/logos/kalolyticLogoW.svg';
export const COMPANY_LOGO_ISOPENSIDEBAR = '/static/logos/kalolyticLogoIcon.svg';
export const COMPANY_URL = 'http://kalolytic.com/';
export const COMPANY_NAME = 'Kalolytic';
export const COPYRIGHT_YEAR = new Date().getFullYear();
